export function getMetadataAvatarContentType(content: Uint8Array): string {
  if (content.length >= 8
    && content[0] === 0x89 && content[1] === 0x50 && content[2] === 0x4e && content[3] === 0x47
    && content[4] === 0x0d && content[5] === 0x0a && content[6] === 0x1a && content[7] === 0x0a) {
    return 'image/png';
  }
  if (content.length >= 12
    && content[0] === 0x52 && content[1] === 0x49 && content[2] === 0x46 && content[3] === 0x46
    && content[8] === 0x57 && content[9] === 0x45 && content[10] === 0x42 && content[11] === 0x50) {
    return 'image/webp';
  }
  if (content.length >= 3
    && content[0] === 0xff && content[1] === 0xd8 && content[2] === 0xff) {
    return 'image/jpeg';
  }
  if (content.length >= 6
    && content[0] === 0x47 && content[1] === 0x49 && content[2] === 0x46
    && content[3] === 0x38 && (content[4] === 0x37 || content[4] === 0x39) && content[5] === 0x61) {
    return 'image/gif';
  }
  return 'image/webp';
}
